/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreeTextAnswerUpdatePayloadRequest
 */
export interface FreeTextAnswerUpdatePayloadRequest {
    /**
     * 
     * @type {string}
     * @memberof FreeTextAnswerUpdatePayloadRequest
     */
    correctAnswer: string;
    /**
     * 
     * @type {number}
     * @memberof FreeTextAnswerUpdatePayloadRequest
     */
    question: number;
}

/**
 * Check if a given object implements the FreeTextAnswerUpdatePayloadRequest interface.
 */
export function instanceOfFreeTextAnswerUpdatePayloadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "correctAnswer" in value;
    isInstance = isInstance && "question" in value;

    return isInstance;
}

export function FreeTextAnswerUpdatePayloadRequestFromJSON(json: any): FreeTextAnswerUpdatePayloadRequest {
    return FreeTextAnswerUpdatePayloadRequestFromJSONTyped(json, false);
}

export function FreeTextAnswerUpdatePayloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreeTextAnswerUpdatePayloadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'correctAnswer': json['correct_answer'],
        'question': json['question'],
    };
}

export function FreeTextAnswerUpdatePayloadRequestToJSON(value?: FreeTextAnswerUpdatePayloadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'correct_answer': value.correctAnswer,
        'question': value.question,
    };
}

